<loading *ngIf="loading">
  <ng-container>Loading latest blog posts</ng-container>
</loading>

<div class="items">
  <a *ngFor="let item of data?.posts" [href]="item.link" target="_blank" rel="noopener" class="item row">
    <div class="col-3 date">{{item.createdAt | date}}</div>
    <div class="col-9 title" [innerHTML]="item?.title"></div>
  </a>
</div>